import {
	Button,
	Filters,
	Modal,
	ResourceItem,
	ResourceList,
	Thumbnail,
} from "@shopify/polaris"
import { useEffect, useState } from "react"
import useDebounce from "../hooks/useDebounce.js"
import { useGQL } from "../hooks/useGQL.js"
import { useTranslation } from "react-i18next"

export const ProductPicker = ({ onProductPicked }) => {
	const { t } = useTranslation()
	const gql = useGQL()

	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [query, setQuery] = useState("")
	const [loading, setLoading] = useState(false)
	const [products, setProducts] = useState([])

	const debouncedQuery = useDebounce(query, 1500)

	const fetchProducts = async (query = null) => {
		const defaultQuery = "first: 10, reverse: true"

		setLoading(true)
		const res = await gql(`query {
			products(${query || defaultQuery}) {
				nodes {
					id
					title
					featuredMedia {
						preview {
							image {
								url
							}
						}
					}
				}
			}
		}`)
		setLoading(false)

		if (res?.data?.products?.nodes?.length) {
			const productsToSet = res.data.products.nodes.map((product) => {
				return {
					id: product.id,
					title: product.title,
					image: product?.featuredMedia?.preview?.image?.url || null,
				}
			})

			setProducts(productsToSet)
		}
	}

	const renderProduct = (product) => {
		const media = <Thumbnail size="medium" source={product?.image || ""} />

		return (
			<ResourceItem
				id={product.id || ""}
				media={media}
				onClick={() => {
					setModalIsOpen(false)
					onProductPicked({ id: product.id, name: product.title })
				}}
			>
				<p style={{ fontSize: "0.9rem", lineHeight: "1.1" }}>
					{product.title || "???"}
				</p>
			</ResourceItem>
		)
	}

	useEffect(() => {
		if (modalIsOpen && products.length === 0) {
			fetchProducts()
		} else {
			setProducts([])
			setQuery("")
		}
	}, [modalIsOpen])

	useEffect(() => {
		if (debouncedQuery) {
			fetchProducts(`first: 10, query: "title:${debouncedQuery}*"`)
		} else if (debouncedQuery === "" && modalIsOpen) {
			fetchProducts()
		}
	}, [debouncedQuery])

	return (
		<div style={{ width: "fit-content", margin: "auto" }}>
			<Button plain onClick={() => setModalIsOpen(true)}>
				{t("kopy_pages.or_pick_an_existing_product_from_your_store")}
			</Button>

			<Modal
				title={t("kopy_pages.pick_a_product_from_your_store")}
				open={modalIsOpen}
				onClose={() => setModalIsOpen(false)}
			>
				<ResourceList
					resourceName={{
						singular: "product",
						plural: "products",
					}}
					items={products}
					renderItem={renderProduct}
					loading={loading}
					filterControl={
						<Filters
							filters={[]}
							queryValue={query}
							onQueryChange={(query) => setQuery(query)}
							onQueryClear={() => setQuery("")}
						/>
					}
				/>
			</Modal>
		</div>
	)
}
